//	Own-want button set
import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '@material-ui/core'
import classNames from 'classnames'
import styles from './FollowButton.icss'

class FollowButton extends React.Component {
	static getDerivedStateFromProps(props, state) {
		// only update on props change (let state changes go through)
		if (props === state.prevProps) {
			return null
		}
		// put own / want in state to allow the ui to be optimistically updated
		const { follow } = props
		return { follow, prevProps: props }
	}

	constructor(props) {
		super(props)

		this.state = {}

		this.doFollowSet = this.doFollowSet.bind(this)
	}

	doFollowSet() {
		this.setState((state) => {
			const follow = !state.follow
			this.props.followSet(follow)
			return { follow }
		})
	}

	render() {
		const { smallerButtons, className, follow } = this.props // eslint-disable-line no-unused-vars
		const baseClasses = [...smallerButtons ? [styles.smallerButtons] : []]

		return (
			<span className={classNames(styles.ownWant, className)}>
				<Button variant="contained" classes={{ root: classNames(styles.compactButton, ...baseClasses, { [styles.selected]: this.state.follow }) }} onClick={this.doFollowSet}>
					{this.context.translate('Follow')}
				</Button>
			</span>
		)
	}
}

FollowButton.propTypes = {
	className: PropTypes.string,
	follow: PropTypes.bool,
	smallerButtons: PropTypes.bool,
	followSet: PropTypes.func
}

FollowButton.defaultProps = {
	className: undefined,
	smallerButtons: true,
	follow: false,
	followSet: () => {}
}

FollowButton.contextTypes = {
	translate: PropTypes.func
}

export default FollowButton



// WEBPACK FOOTER //
// ./src/components/FollowButton.jsx